import { render, staticRenderFns } from "./lazadabinditems.vue?vue&type=template&id=6b16eba9&"
import script from "./lazadabinditems.vue?vue&type=script&lang=js&"
export * from "./lazadabinditems.vue?vue&type=script&lang=js&"
import style0 from "./lazadabinditems.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports